import { render, staticRenderFns } from "./CampusesInput.vue?vue&type=template&id=745dc16f&scoped=true"
import script from "./CampusesInput.vue?vue&type=script&lang=ts"
export * from "./CampusesInput.vue?vue&type=script&lang=ts"
import style0 from "./CampusesInput.vue?vue&type=style&index=0&id=745dc16f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745dc16f",
  null
  
)

export default component.exports